import { BankAccountAPI } from "../api"

export class BankAccount {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createBankAccount(postData) {
    const { data } = await BankAccountAPI.createBankAccount(postData);
    return new BankAccount(data.result)
  }
  static async getBankAccounts(projectId) {
    const { data } = await BankAccountAPI.getBankAccounts(projectId);
    return data.result.map((item) => new BankAccount(item));
  }
  static async updateBankAccount(postData) {
    const { data } = await BankAccountAPI.updateBankAccount(postData);
    return new BankAccount(data.result)
  }
  static async removeBankAccount(bankAccountId) {
    const { data } = await BankAccountAPI.removeBankAccount(bankAccountId);
    return new BankAccount(data.result)
  }
}